import { imageId } from './ImageStore';

export const updateImageId = (value) => imageId.update((oldValue) => value);
